/** 전국 17개 시도 + 시군구 정적 맵 (행정안전부 법정동코드 기준) */
import { SIDO_17 } from '@/lib/cl-core/names';

/** 시도 17개(DB apt_sites.region 키) — 원본은 cl-core/names SIDO_17(Deno 공용). HC 정리 2026-10-24: 사본 금지. */
export const REGIONS = SIDO_17;
/** 같은 17개를 `string` 으로 비교하는 곳(includes·Set)용 — 튜플 리터럴 타입이 걸리지 않는다. */
export const SIDO_NAMES: readonly string[] = SIDO_17;

export const SIGUNGU_MAP: Record<string, string[]> = {
  '서울': ['강남구','강동구','강북구','강서구','관악구','광진구','구로구','금천구','노원구','도봉구','동대문구','동작구','마포구','서대문구','서초구','성동구','성북구','송파구','양천구','영등포구','용산구','은평구','종로구','중구','중랑구'],
  '부산': ['강서구','금정구','기장군','남구','동구','동래구','부산진구','북구','사상구','사하구','서구','수영구','연제구','영도구','중구','해운대구'],
  '대구': ['군위군','남구','달서구','달성군','동구','북구','서구','수성구','중구'],
  '인천': ['강화군','계양구','남동구','동구','미추홀구','부평구','서구','연수구','옹진군','중구','검단구','서해구','영종구','제물포구'],   // 2026-07-01 개편 신설 4구 추가(옛 중·동·서구는 과거 거래·기존 행 때문에 유지) — next-46
  '광주': ['광산구','남구','동구','북구','서구'],
  '대전': ['대덕구','동구','서구','유성구','중구'],
  '울산': ['남구','동구','북구','울주군','중구'],
  '세종': ['세종시'],
  '경기': ['가평군','고양시','과천시','광명시','광주시','구리시','군포시','김포시','남양주시','동두천시','부천시','성남시','수원시','시흥시','안산시','안성시','안양시','양주시','양평군','여주시','연천군','오산시','용인시','의왕시','의정부시','이천시','파주시','평택시','포천시','하남시','화성시'],
  '강원': ['강릉시','고성군','동해시','삼척시','속초시','양구군','양양군','영월군','원주시','인제군','정선군','철원군','춘천시','태백시','평창군','홍천군','화천군','횡성군'],
  '충북': ['괴산군','단양군','보은군','영동군','옥천군','음성군','제천시','증평군','진천군','청주시','충주시'],
  '충남': ['계룡시','공주시','금산군','논산시','당진시','보령시','부여군','서산시','서천군','아산시','예산군','천안시','청양군','태안군','홍성군'],
  '전북': ['고창군','군산시','김제시','남원시','무주군','부안군','순창군','완주군','익산시','임실군','장수군','전주시','정읍시','진안군'],
  '전남': ['강진군','고흥군','곡성군','광양시','구례군','나주시','담양군','목포시','무안군','보성군','순천시','신안군','여수시','영광군','영암군','완도군','장성군','장흥군','진도군','함평군','해남군','화순군'],
  '경북': ['경산시','경주시','고령군','구미시','김천시','문경시','봉화군','상주시','성주군','안동시','영덕군','영양군','영주시','영천시','예천군','울릉군','울진군','의성군','청도군','청송군','칠곡군','포항시'],
  '경남': ['거제시','거창군','고성군','김해시','남해군','밀양시','사천시','산청군','양산시','의령군','진주시','창녕군','창원시','통영시','하동군','함안군','함양군','합천군'],
  '제주': ['서귀포시','제주시'],
};

export type Sido = typeof REGIONS[number];

// s265 — REGIONS alias (동일 17개) + 인접 지역 매핑.
// cascade fallback RPC (get_apt_*_cascade) 의 L3 (인접 지역 포함) 단계와 매칭.
// 인접 정의: 행정구역 직접 인접 + 일반적 생활권 (예: 서울 ↔ 경기/인천).
export const REGIONS_17 = REGIONS;
export type Region17 = (typeof REGIONS_17)[number];

export const ADJACENT_REGIONS: Record<string, string[]> = {
  '서울': ['경기', '인천'],
  '부산': ['경남', '울산'],
  '대구': ['경북', '경남'],
  '인천': ['경기', '서울'],
  '광주': ['전남', '전북'],
  '대전': ['충남', '충북', '세종'],
  '울산': ['부산', '경남'],
  '세종': ['대전', '충남', '충북'],
  '경기': ['서울', '인천', '강원'],
  '강원': ['경기', '경북'],
  '충북': ['충남', '세종', '경북'],
  '충남': ['대전', '세종', '충북'],
  '전북': ['전남', '광주', '충남'],
  '전남': ['전북', '광주'],
  '경북': ['경남', '대구', '강원'],
  '경남': ['부산', '울산', '경북'],
  '제주': ['전남'],
};
